import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { forkJoin, map, Observable, take, tap } from 'rxjs';
import { HFQDiscountDetailsComponent } from 'src/app/component/modal/template/sales/hfq-discount-details/hfq-discount-details.component';
import { RssDiscountDetailsComponent } from 'src/app/component/rss-discount-details/rss-discount-details.component';
import { StatusSalesComponent } from 'src/app/component/modal/template/sales/status-sales/status-sales.component';
import { RssDocumentUploadedComponent } from 'src/app/component/rss-document-uploaded/rss-document-uploaded.component';
import { SaleParameter } from 'src/app/model/RSS/SaleParameter.model';
import { Sales } from 'src/app/model/RSS/Sales.model';
import { RssService } from 'src/app/services/rss.service';
import { ngxCsv} from 'ngx-csv/ngx-csv';
import { AuthService } from 'src/app/services/auth.service';
import { SelectionModel } from '@angular/cdk/collections';
import { AgentAssignment } from 'src/app/model/RSS/AgentAssignment.model';

import { RssBotStatusDetailsComponent } from 'src/app/component/rss-bot-status-details/rss-bot-status-details.component';
import { Processinginfo } from 'src/app/model/RSS/BotStatus.model';
import { Authorization } from 'src/app/model/RSS/Authorization.model';
import { ActivatedRoute, Router } from '@angular/router';
// import { Transform } from 'stream';

@Component({
  selector: 'app-rss-dashboard-page',
  templateUrl: './rss-dashboard-page.component.html',
  styleUrls: ['./rss-dashboard-page.component.css']
})
export class RssDashboardPageComponent implements OnInit, AfterViewInit {

  user: AccountInfo;

  pageIndex: number = 0;
  pageSize: number = 100;
  length: number;
  numSelected: number = 0;
  disabled: boolean = true;
  isAssignModeOn: boolean = true;
  public salesTotal: number = 0;
  public dataSource = new MatTableDataSource<Sales>();
  public selection = new SelectionModel<Sales>(true, []);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public sales$: Observable<Sales[]>;
  //public figures: SalesFigures;
  public dateToday: Date = new Date();
  public busy: boolean = false;
  public searchedText: string = '';
  public agents: any[] = [];
  public SalesList: Sales[];
  public agentsSelectedControl = new FormControl('');
  public agentsSelected: any;
  public isDisplayingOnlyUnassigned = false;
  public authorization: Authorization = new Authorization();
  public urlGriad: string = 'MRSS';
  startDate: any;
  endDate: any;
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  public range = new UntypedFormGroup({
    start: new UntypedFormControl(new Date()),
    end: new UntypedFormControl(new Date()),
  });
  constructor(
    private rssService: RssService,
    private authService: MsalService,
    public dialog: MatDialog,
    private graph: AuthService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private urlRouter: Router
  ) { }

  displayedColumns: string[] = [
    'select',
    'status',
    'botStatus',
    'clientCode',
    // 'realexReferenceID',
    'customerName',
    'dateSold',
    'insurer',
    'isAlternativeOffer',
    'price',
    'paidAmount',
    'keycare',
    'agentAssigned',
    'documents',
    'inceptionDate',
  ];
  ngOnInit(): void {

    const currentRoute = this.urlRouter.url.split('/').pop();
    if (currentRoute) {
      this.urlGriad = currentRoute;
    }

    console.log(this.authService.instance.getAllAccounts()[0]);
    this.listSales();
    this.user = this.authService.instance.getAllAccounts()[0];
    this.authorization = this.route.snapshot.data['authorization'];
    console.log(this.authorization);

    // no need for QD
    // this.graph.getGroupUserDetail().subscribe({
    //   next: (x) => {
    //     debugger
    //     this.agents = x.value;
    //      console.log(this.agents);
    //   },
    //   error: (e) => {
    //     console.error(e);
    //   },
    // });
  }
  title = "Export to CSV";
  
  exportCSV(a){
    // this.SalesList
    // let data = [
    //   {
    //     name: "john",
    //     age: 24,
    //     country: "USA"
    //   }
    // ]

    let dataFull = ({globalPaymentReference, saleDate, policyCode, payer, payment}) => 
      ({
        globalPaymentReference, 
        saleDate, 
        policyCode,
        payer_first_name: payer.first_name,
        payer_last_name: payer.last_name,
        payer_email: payer.email,
        payer_billing_address_city: payer.billing_address.city,
        payer_billing_address_country: payer.billing_address.country,
        payer_billing_address_line_1: payer.billing_address.line_1,
        payer_billing_address_line_2: payer.billing_address.line_2,
        payer_billing_address_postcode: payer.billing_address.postcode,
        payment_amount: payment.amount,
        payment_depositAmount: payment.depositAmount,
        payment_hasKeycare: payment.hasKeycare,
        payment_keyCareAmount: payment.keyCareAmount,
        payment_isFullPayment: payment.isFullPayment,
        payment_monthlyAmount: payment.monthlyAmount,
        payment_policyStartDate: payment.policyStartDate,
        payment_premiumAmount: payment.premiumAmount,
        payment_timeCreated: payment.timeCreated,
        payment_reference: payment.reference,
        offer_companyName: payment.offer.companyName,
        offer_insurerName: payment.offer.insurerName,
        offer_isCurrentOffer: payment.offer.isCurrentOffer,
        offer_payInFull: payment.offer.payInFull,
        offer_premium: payment.offer.premium,

      });
      let concatenatedLicenceNumbers = a
      .flatMap(item => item.validationLicences ? item.validationLicences.map(licence => licence.licence.number) : [])
      .join('');


      let concatenatedImg = a
      .flatMap(item => item.validationLicences ? item.validationLicences.map(licence => licence.licence.imagesUrl) : [])
      .join('');
      debugger
      let dataS = ({globalPaymentReference, saleDate, policyCode,processinginfo, agentAssignment,payer, payment,status, validationLicences}) => 
        ({
          policyCode,
          StatusList: status ?? '',
          botStatus: processinginfo?.status ?? '',
          realexReferenceID: globalPaymentReference,
          dateSold: saleDate,
          timeSold: payment.timeCreated,
          product: 'Motor',
          offer: payment.offer.isCurrentOffer? 'Current Offer' : 'Alternative Offer',
          Insurer: payment.offer.insurerName,
          price: payment.offer.premium,
          paidAmount: payment.amount,
          agentAssigned: agentAssignment?.agentAssignedName,
          keyCare: payment.hasKeyCare,
          driverNumber: validationLicences?.map(a =>a.licence.typeOfDoc =='text').some(v => v === true),
          documents: validationLicences?.map(a =>a.licence.typeOfDoc =='file').some(v => v === true),
      
        });
        

      let result = a.map(dataS)
    
      let options = {
      title: 'A',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true, 
      showTitle: false,
      useBom: false,
      noDownload: false,
      useHeader: true,
      headers: ['Policy Code', 'Status','Bot Status' , 'Realex Reference ID', 'Date Sold',
         'Time Sold', 'Product', 'Alternative Offer', 'Insurer', 'Price', 'Paid Amount','Agent Assigned', 'Key Care', 'Driver Number', 'Documents'],
      
   
    nullToEmptyString: true,
    
    }
    let datepipe:DatePipe = new DatePipe('en-IE'); 

    // let fileName = this.datepipe.transform(new Date(), 'MM/dd/yy hh:mm'),

    new ngxCsv(result, 'RSS_Sales '+this.datepipe.transform(new Date(), 'dd/MM/yy hh:mm'), options);
    console.log(a)
  }
  dateRangeChanged() {
    // this.resetPaging();
    //this.searchedText = '';
    this.listSales();
  }
  setAgentsSelected() {

    let selected = this.selection.selected;
    selected.map((x) => {
      x.agentAssignment = <AgentAssignment>{
        agentAssignedEmail: this.agentsSelected.userPrincipalName,
        agentAssignedName: this.agentsSelected.displayName,
       leadEmail: this.user.username,
        dateAssigned:new Date()
      };
    });

    // if (this.isDisplayingOnlyUnassigned) {
    //   this.assignedItems.push(...selected);
    //   this.unassignedItems.push();
    //   this.data.data = this.removeItemsFromArray(
    //     this.data.data,
    //     this.assignedItems
    //   );
    // } 

    selected.map((x) => {
      const selected = this.dataSource.data.find(
        (i2) => i2.policyCode == x.policyCode
      );
      return selected ? { ...x, ...selected } : x;
    });
    this.selection.clear();
    if (selected.length > 0) {
      selected.forEach(element => {
        this.saveSale(element);
      });
      
    }
    //   this.onboardingService.saveAssignedTask(selected).subscribe((res) => {
    //     // console.log(res);

    //     let policies = selected.map((x) => {
    //       return {
    //         policyCode: x.policyCode,
    //         dateUploaded: x.dateUploaded,
    //       };
    //     });

    //     let assignment = <AgentAssignment>{
    //       sessionId: sessionStorage.getItem('sessionId'),
    //       policies: policies,
    //       leadEmail: this.userLoggedIn.username,
    //       agentAssignedEmail: selected.map((x) => x.agentEmail)[0],
    //       eventTime: new Date(),
    //     };

    //     debugger;
    //     this.eventService.assignTaskEvent(assignment);
    //   });
    // }
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'dateSold':
          return this.compare(a.payment.timeCreated, b.payment.timeCreated, isAsc);
        case 'customerName':
          return this.compare(a.payer.name, b.payer.name, isAsc);
        case 'price':
          return this.compare(a.payment.amount, b.payment.amount, isAsc);
        case 'inceptionDate':
          return this.compare(a.payment.policyStartDate, b.payment.policyStartDate, isAsc);
        case 'agentAssigned':
          return this.compare(a.agentAssignment?.agentAssignedName, b.agentAssignment?.agentAssignedName, isAsc);
        case 'botStatus':
          return this.compare(a.processinginfo?.status, b.processinginfo?.status, isAsc);
        case 'status':
          return this.compare(a?.status, b?.status, isAsc);
        default:
          return 0;
      }
    });
  }
  compare(a: number | string | Date | null | undefined, b: number | string | Date | null | undefined, isAsc: boolean) {
    if (a == null && b == null) {
      return 0; // Both are null or undefined, considered equal
    }
    if (a == null) {
      return isAsc ? -1 : 1; // Null or undefined values are considered smaller
    }
    if (b == null) {
      return isAsc ? 1 : -1; // Null or undefined values are considered smaller
    }
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  searchChanged() {
    // this.resetPaging();
    // if (this.searchedText !== '') {
    this.listSales();
    // }
  }

  getTodaySales() {
    this.range = new UntypedFormGroup({
      start: new UntypedFormControl(new Date()),
      end: new UntypedFormControl(new Date()),
    });

    this.listSales();
  }


  listSales() {
    let queryAditional;

    let saleParameter;
    if (
      this.range.controls['start'].value === null ||
      this.range.controls['end'].value === null
    ) {
    } else if (
      this.range.controls['start'].value !== null &&
      this.range.controls['end'].value !== null
    ) {
      this.dataSource.data = [];
      this.busy = true;
      let PolicyType = this.urlGriad === 'MRSS' ? 'Motor' : this.urlGriad === 'HRSS' ? 'Home' : this.urlGriad === 'VRSS' ? 'Van' : null;

      saleParameter = new SaleParameter(
        this.datepipe.transform(
          this.range.controls['start'].value,
          'yyyy-MM-dd'
        ),
        this.datepipe.transform(this.range.controls['end'].value, 'yyyy-MM-dd'),
        this.searchedText,
        PolicyType,
        '04'
      );

      this.startDate = this.datepipe.transform(this.range.controls['start'].value, 'dd/MM/yyyy');

      this.endDate = this.datepipe.transform(this.range.controls['end'].value, 'dd/MM/yyyy');


      this.rssService
        .getSales(saleParameter)
        .pipe(
          tap((page) => {
           
            this.busy = false;
            this.salesTotal = page.saleTotal;
            console.log("this.SalesList: ",page.salesList)

            const now = new Date();
            let fifteenMinutesAgo = now.getTime();
            if(PolicyType === 'Motor') {
                fifteenMinutesAgo = now.getTime() - 15 * 60 * 1000; 
             }
            // Filter the salesList to get only the items created more than 15 minutes ago
            this.SalesList = page.salesList.filter(item => {
              const createdTime = Number.parseInt(item.id);
              return createdTime < fifteenMinutesAgo;
            });
            this.dataSource.data = this.SalesList;

            // const updateRequests = page.salesList.map((sale) =>
            //   this.rssService.getListFile(sale.policyCode).pipe(
            //     map((extraData) => ({
            //       ...sale, 
            //       uploadedFile: extraData// Update hasUploadedFile 
            //     }))
            //   )
            // );


            // forkJoin(updateRequests).subscribe((updatedSales) => {
            //   this.dataSource.data = updatedSales; // Update the  data
              
            // });
          })
        )
        .subscribe({
          error: (error) => {
            this.busy = false;
            console.error(error);
          }
        });
    }
  }
  filterUnassignedOnly() {
    this.isDisplayingOnlyUnassigned = !this.isDisplayingOnlyUnassigned;


    if (this.isDisplayingOnlyUnassigned) {
      this.dataSource.data = this.SalesList.filter((x) => !x.agentAssignment);
    } else {
      this.dataSource.data = this.SalesList;
    }
  }
  openBotStatusDialog(botStatus: Processinginfo) {
    debugger
    this.dialog.open(RssBotStatusDetailsComponent, {
      width: '100%',
      maxWidth: '800px',
      height: 'auto',
      hasBackdrop: true,
      maxHeight: '600',
      data: botStatus,
    });
    }


  openStatusUpdateDialog(sale: Sales) {
    debugger
    const dialogRef = this.dialog.open(StatusSalesComponent, {
      width: '100%',
      maxWidth: '700px',
      height: 'auto',
      hasBackdrop: true,
      maxHeight: '400',
      data: { sale, username: this.user.username },
    });
    dialogRef.afterClosed().subscribe((result) => {
      debugger
      if (result !== undefined && result.selectedStatus !== undefined) {
        sale.status = result.selectedStatus;
        this.saveSale(sale);
      }
    });
  }
  saveSale(sales: Sales) {
    this.rssService.saveSale(sales).subscribe({
      next: (res) => {
        console.log("Sale saved")
      },
      error: (error) => {
        console.log("error " + error)
      }
    });

  }
  openDiscountDetailsDialog(sale) {
    this.dialog.open(HFQDiscountDetailsComponent, {
      width: '100%',
      maxWidth: '1000px',
      height: 'auto',
      hasBackdrop: true,
      maxHeight: '1000px',
      data: sale,
    });
  }
  openDiscountRssDetailsDialog(sale) {
    this.dialog.open(RssDiscountDetailsComponent, {
      width: '100%',
      maxWidth: '1000px',
      height: '100%',
      hasBackdrop: true,
      maxHeight: '1000px',
      data: sale,
    });
  }

  openDocumentDialog(sale) {
    console.log(sale);
    const dialogRef = this.dialog.open(RssDocumentUploadedComponent, {
      width: '100%',
      maxWidth: '1000px',
      height: 'auto',
      hasBackdrop: true,
      minHeight: '600px',
      data: {
        validationLicences: sale.validationLicences,
        policyCode: sale.policyCode,
        application:'RSS',
        brokerName:'Chill'
      },
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }
    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
      // setTimeout(() => {
      this.numSelected = this.selection.selected.length;
      // }, 0);
  
      const numRows = this.dataSource.data.length;
      return this.numSelected === numRows;
    }
    /** Selects all rows if they are not all selected; otherwise clear selection. */
    toggleAllRows() {
      if (this.isAllSelected()) {
        this.numSelected = 0;
        this.selection.clear();
        return;
      }
  
      this.selection.select(...this.dataSource.data);
    }

  hasAmendmentValidationStep(element: Sales): boolean {
    return element.validationLicences?.some(vl => vl.licence.validationStep !== 'pre') ?? false;
  }
}
